export type MilestoneType =
  | "projectKickoff"
  | "designApproval"
  | "shopDrawingSubmission"
  | "shopDrawingApproval"
  | "productionStart"
  | "firstPanelCast"
  | "productionComplete"
  | "shippingStart"
  | "shippingComplete"
  | "erectionStart"
  | "erectionComplete"
  | "projectCompletion"
  | "custom";

export type ScheduleStatus =
  | "upcoming"
  | "pending"
  | "inProgress"
  | "completed"
  | "delayed"
  | "onHold"
  | "cancelled";

export interface JobSchedule {
  id: number;
  jobId: number;
  milestoneType: MilestoneType;
  milestoneName: string;
  description?: string;
  scheduledDate?: string;
  originalScheduledDate?: string;
  actualDate?: string;
  status: ScheduleStatus;
  progressPercentage: number;
  responsibleParty?: string;
  responsibleUserId?: number;
  dependsOnMilestoneId?: number;
  leadTimeDays?: number;
  notes?: string;
  completionNotes?: string;
  isCriticalPath?: boolean;
  isVisible?: boolean;
  sortOrder?: number;
  varianceDays?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface JobScheduleCreate {
  jobId: number;
  milestoneType: MilestoneType;
  milestoneName: string;
  description?: string;
  scheduledDate?: string;
  originalScheduledDate?: string;
  actualDate?: string;
  status?: ScheduleStatus;
  progressPercentage?: number;
  responsibleParty?: string;
  responsibleUserId?: number;
  dependsOnMilestoneId?: number;
  leadTimeDays?: number;
  notes?: string;
  completionNotes?: string;
  isCriticalPath?: boolean;
  isVisible?: boolean;
  sortOrder?: number;
}

export interface JobSchedulePatch {
  milestoneType?: MilestoneType;
  milestoneName?: string;
  description?: string;
  scheduledDate?: string;
  originalScheduledDate?: string;
  actualDate?: string;
  status?: ScheduleStatus;
  progressPercentage?: number;
  responsibleParty?: string;
  responsibleUserId?: number;
  dependsOnMilestoneId?: number;
  leadTimeDays?: number;
  notes?: string;
  completionNotes?: string;
  isCriticalPath?: boolean;
  isVisible?: boolean;
  sortOrder?: number;
}

export const milestoneDisplayNames: Record<MilestoneType, string> = {
  projectKickoff: "Project Kickoff",
  designApproval: "Design Approval",
  shopDrawingSubmission: "Shop Drawing Submission",
  shopDrawingApproval: "Shop Drawing Approval",
  productionStart: "Production Start",
  firstPanelCast: "First Panel Cast",
  productionComplete: "Production Complete",
  shippingStart: "Shipping Start",
  shippingComplete: "Shipping Complete",
  erectionStart: "Erection Start",
  erectionComplete: "Erection Complete",
  projectCompletion: "Project Completion",
  custom: "Custom",
};

export const getStatusColor = (
  status?: ScheduleStatus
): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" => {
  switch (status) {
    case "upcoming":
      return "info";
    case "pending":
      return "warning";
    case "inProgress":
      return "primary";
    case "completed":
      return "success";
    case "delayed":
      return "error";
    case "onHold":
      return "warning";
    case "cancelled":
      return "default";
    default:
      return "default";
  }
};
